import { Card } from '@nackle/paper';
import { Plus } from '@nackle/icons';
import SlideInPanel from 'app/components/shared/slide-in-panel';
import { formatCmxRoomNameKey } from 'routes/updatecmx/cmxKeyNames';
import { TranslationEditorWrapper } from 'routes/updatecmx/TranslationEditorWrapper';
import { CardHeader } from 'shared/card-header';
import { clearRoom } from 'arcade/sections/rooms/actions';
import { getRoomId } from 'arcade/sections/rooms/selectors';
import React, { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import { HasPermission } from 'shared/HasPermission';
import ArcadeRoom from './room';

export interface ArcadeRoomButtonAndPanelProps {
    readonly clearRoom: () => unknown;
    readonly roomId?: string;
}

interface State {
    /**
     * Keep track of whether there's a translation pane open because Overlays like to hog focus from each other,
     * so we need to be able to turn off some features on the parent overlay while it's open
     */
    childPanelOpen: boolean;
}

// const ELEVATION = Elevation.ONE;

export class ArcadeRoomButtonAndPanelImpl extends Component<any, State> {
    state: State = {
        childPanelOpen: false,
    };

    onPanelClose = () => this.props.clearRoom();

    render () {
        const {
            roomId
        } = this.props;

        let localizableContentEditors: ReactNode;
        if (roomId) {
            localizableContentEditors = (
                <>
                    <TranslationEditorWrapper
                        keyName={formatCmxRoomNameKey(roomId)}
                        label="Room Name"
                        onPanelOpening={this.handleChildPanelOpening}
                        onPanelClosed={this.handleChildPanelClosed}
                    />
                </>
            );
        } else {
            localizableContentEditors = (
                <Card title="Localizable content can be configured after the room is created"/>
            );
        }

        return (
            <HasPermission app="arcade-api" permission="create-room">
                {(hasPermission: boolean) => (
                    <SlideInPanel
                        buttonProps={{
                            icon: <Plus/>,
                            id: 'createArcadeRoomSlideInPanelButton',
                            // intent: Intent.PRIMARY,
                            text: 'Create Arcade Room',
                    }}
                        childPanelOpen={this.state.childPanelOpen}
                        disabled={!hasPermission}
                        slide={!!roomId}
                        onClose={this.onPanelClose}
                        title={`${roomId ? 'Update' : 'Create'} Arcade Room`}
                        className={'arcade-form'}
                    > 
                        <ArcadeRoom />

                        <br />

                        <Card>
                            <CardHeader className="localizable-content" title="Localizable Content" />
                            {localizableContentEditors}
                        </Card>
                    </SlideInPanel>
                )}
            </HasPermission>
        );
    }

    handleChildPanelOpening = () => this.setState({ childPanelOpen: true });
    handleChildPanelClosed = () => this.setState({ childPanelOpen: false });
}

const mapStateToProps = state => ({
    roomId: getRoomId(state),
});

const mapDispatchToProps = {
    clearRoom
};

export const ArcadeRoomButtonAndPanel = connect(mapStateToProps, mapDispatchToProps)(ArcadeRoomButtonAndPanelImpl);
